import {observable, computed, autorun, map, runInAction} from 'mobx';

// Reactive computed methods that depend on the clock cannot run
// constantly (as time is always changing)
// So they use this variable, which needs to be updated with current
// time at sensible intervals depending on the need of updating the
// model.


class ReactiveClock {
  @observable reactiveTime = null;
  constructor() {
    this.reactiveTime = new Date();
  }
  tickClock() {
    this.reactiveTime = new Date();
  }
}

var singletonClock = new ReactiveClock();

function slowTickingInBackground() {
  runInAction("Updating reactive clock tick", () => {
    singletonClock.tickClock();
  });
  // Every 10 second we tick the clock, regardless of any other
  // events ticking it, just to make sure any UI messages such as
  // 3 minutes ago etc. will be updated eventually
  setTimeout( slowTickingInBackground, 10000);
}
// Kick the slow ticking started :
slowTickingInBackground();

export default singletonClock;



/** WEBPACK FOOTER **
 ** ./src/utils/ReactiveClock.js
 **/